<template>
    <div class="instant-chat-intro" v-if="showIntro">
        <div class="text" v-html="body" />
        <i @click="close" class="zmdi zmdi-close" />
    </div>
</template>
<script>
export default {
    name: 'InstantChatIntro',
    data: () => ({
        showIntro: null,
    }),
    computed: {
        chat() {
            return this.$store.getters.chat || {}
        },
        body() {
            return this.$translate('ACTION_INFORM_INSTANT_CHAT').replace(/%s/, this.$nameOrNick(this.chat.user))
        },
    },
    mounted() {
        this.init()
    },
    watch: {
        chat(oldVal, newVal) {
            if (oldVal && newVal && oldVal.id !== newVal.id) {
                this.init()
            }
        },
    },
    methods: {
        async init() {
            const show = window.localStorage.getItem('showAcceptedUserInfo')
            this.showIntro = show === null
        },
        close() {
            this.showIntro = false
        },
    },
}
</script>
